<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-base-dialog v-model="isShow" :option="option"
                   @close="closeBtnClick"
                   @confirm="closeBtnClick"
                   v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward')" v-if="!showDefaultGiftReceivePopText">
          <div>恭喜你获得了</div>
          <div v-for="(item,index) in packageNames" :key="index">{{ item }}</div>
        </div>
        <div :style="defaultGiftStyle" v-else>
          <div>{{ defaultGiftReceivePopText }}</div>
        </div>
      </template>
      <template slot="fotter">
        <div v-if="checkGiftType('packageRealGift')" :style="actionStyle">
          <button
            class="ceiba-base-dialog-ft-button"
            :style="inputAddressStyle"
            @click="signAddress"
          >
          </button>
          <div :class="getCss('address-tips')">提示：实物奖励需填写地址才可以收到.~</div>
        </div>
        <div v-if="checkGiftType('cdk')" :style="actionStyle">
          <p :class="getCss('cdk-tips')">CDK: {{ CDKeyValue }}</p>
          <div :style="actionStyle" :class="getCss('cdk-action-button')">
            <button
              class="ceiba-base-dialog-ft-button"
              :style="copyStyle"
              @click="copyCDkText"
            >
            </button>
            <button
              class="ceiba-base-dialog-ft-button"
              :style="downloadGameButtonStyle"
              @click="startCallDownload"
            >
            </button>
          </div>

        </div>
        <div v-if="checkGiftType('cash')" :style="actionStyle">
          <button
            class="ceiba-base-dialog-ft-button"
            :style="cashStyle"
            @click="bindWx"
          >
          </button>
          <div :class="getCss('address-tips')">{{ this.packageCashInputText }}</div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CButtonLottery',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-lottery-',
      isReachMaximumLimit: false,
      packageName: '内测资格',
      isShow: false,
      isOpenDownload: true,
      CDKeyValue: '',
      copyCdkIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/copyCDk.png',
      downloadGameIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      packageRealGiftInputIcon: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      copyCdkSuccessTrips: '',
      packageCashInputIcon: '',
      packageCashInputText: '',
      packageId: 0,
    };
  },
  computed: {
    actionStyle() {
      return {
        width: this.dialogConfig.width,
      };
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    computedStyle() {
      const { isStretching } = this.configurationData;
      return {
        backgroundImage: `url(${this.configurationData.rewardImg})`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
        position: 'static',
      };
    },
    inputAddressStyle() {
      return {
        display: 'block',
        backgroundImage: `url(${this.packageRealGiftInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',

        margin: '0 auto',
      };
    },
    copyStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.copyCdkIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    defaultGiftStyle() {
      return {
        fontSize: '0.22rem',
      };
    },
    cashStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.packageCashInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        // backgroundSize:'100% 100%',
        margin: '0 auto',
      };
    },
    downloadGameButtonStyle() {
      return {
        width: '2.2rem',
        height: '0.65rem',
        display: this.isOpenDownload ? 'block' : 'none',
        backgroundImage: `url(${this.downloadGameIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return false;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    packageNames() {
      return this.packageName ? this.packageName.split(',') : '';
    },
    // 设置默认礼包id
    defaultPackageId() {
      const { defaultPackageId = 0 } = this.configurationData;
      return parseInt(defaultPackageId, 10);
    },
    // 抽中默认礼包弹框文案
    defaultGiftReceivePopText() {
      return this.configurationData?.defaultGiftReceivePopText || '';
    },
    // 是否显示默认礼包文案
    showDefaultGiftReceivePopText() {
      return this.defaultPackageId > 0 && this.defaultPackageId === this.packageId && this.defaultGiftReceivePopText;
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      console.log(123123123);
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.actInfo.extendConfig.forceRole,
      });
    },
    closeBtnClick() {
      this.isShow = false;
    },
    initValue() {
      this.copyCdkSuccessTrips = '';
      this.copyCdkIconImage = '';
      this.downloadGameIconImage = '';
      this.isOpenDownload = false;
      this.packageRealGiftInputIcon = '';
      this.packageCashInputIcon = '';
      this.packageCashInputText = '';
    },
    checkGiftType(checkType) {
      const { packageId } = this;
      if (packageId === 0 || !packageId) return false;
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      console.log('receiveGiftCustomConfig = ', receiveGiftCustomConfig);
      const res = receiveGiftCustomConfig?.find(item => parseInt(item.gift_id, 10) === parseInt(packageId, 10));
      const { type = '' } = res || {};
      if (type === 'cdk' && checkType === 'cdk') {
        this.copyCdkSuccessTrips = res?.playload?.copyCdkSuccessTrips ?? '复制成功';
        this.copyCdkIconImage = res?.playload?.copyCdkIconImage ?? '';
        this.downloadGameIconImage = res?.playload?.downloadGameIconImage ?? '';
        this.isOpenDownload = parseInt(res?.playload?.isOpenDownload ?? 1, 10) === 2;
        return true;
      }
      if (type === 'packageRealGift' && checkType === 'packageRealGift') {
        this.packageRealGiftInputIcon = res?.playload?.packageRealGiftInputIcon ?? '';
        return true;
      }
      if (type === 'cash' && checkType === 'cash') {
        this.packageCashInputIcon = res?.playload?.packageCashInputIcon ?? '';
        this.packageCashInputText = res?.playload?.packageCashInputText ?? '';
        return true;
      }
      // todo 实现多个类型判断
      // if (type === 'privateQualification' ){
      //   this.link = res?.playload?.link ?? '';
      //   this.surveyTrip = res?.playload?.trips ?? '点击"确定"跳转填写问卷';
      //   console.log('isShowSurvey', true, this.link, this.surveyTrip);
      //   return  true;
      // }
      return false;
    },
    async signAddress() {
      console.log('signAddress');
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:events:address-fill', {});
    },
    bindWx() {
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', {});
    },
    startCallDownload() {
      this.$eventBus.$emit('ceiba:common:events:call-game-download', {});
    },
    copyCDkText() {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = this.CDKeyValue;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
      this.$toast(this.copyCdkSuccessTrips || '复制cdk成功');
      return true;
    },
    reportFunc(status, giftId) {
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'lottery',
        eventData: {
          gift_id: giftId,
          status,
        },
      });
    },
    async doReward() {
      this.handleClickEvent();
      await this.doHook({
        name: 'click_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
        },
      });
      this.packageName = ''; // 置空
      if (!this.enable) {
        this.alert(this.configurationData.remainTips || '抽奖资格不足');
        return;
      }
      if (!(await this.doHook({ name: 'before_reward' }))) {
        return;
      }
      const totalParams = {
        flowId: this.configurationData.flowID,
        params: {
          role: this.configurationData.needRole ? this.roleInfo : {},
        },
      };
      // costTimes 抽奖次数 用于gbot特定接口进行传参
      let  { costTimes = 0 } = this.configurationData;
      costTimes = parseInt(costTimes, 10) || 0;
      if  (costTimes > 0) {
        totalParams.params.data = {};
        totalParams.params.data = JSON.stringify({ costTimes });
      }
      const response = await this.flowRequest(totalParams);
      this.refreshQua(); // 刷新礼包
      await this.doHook({
        name: 'after_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
          response,
        },
      }); // 后置动作，上报等

      const { ret: rspRet, msg: rspMsg, data = {} } = response;
      // 第一层报错
      if (rspRet !== 0) {
        this.reportFunc('0', '');
        return this.alert(rspMsg);
      }

      const { ret, package_id = '0', packageId: otherPackageId = '0', msg, package_cdkey: cdkey } = data;
      this.packageId = parseInt(package_id, 10) || parseInt(otherPackageId, 10) || 0;
      // 什么都没有领取成功
      // 第二层报错
      if (ret !== 0 || this.packageId === 0) {
        this.reportFunc('0', '');
        return this.alert(msg);
      }
      this.reportFunc('1', package_id || '');
      this.packageName = response.data.msg.replace('恭喜您获得了礼包：', '');
      this.packageName = this.packageName.replace(' ', '');
      this.CDKeyValue = cdkey;
      this.initValue();
      if (this.configurationData.showGiftIcon) { // 如果showGiftIcon为true,弹图片弹窗
        baseComponents.GiftComponent.showGiftDialog({
          meta: {
            packageInfo: response.data,
            iconList: this.configurationData.iconList,
          },
          option: Object.assign({}, this.dialogConfig, {
            dialogStyle: this.dialogConfig?.dialogStyle || {
              color: '#282121',
            },
          }),
        });
      } else {
        this.isShow = true;
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
